import { type MiddlewareFunction, redirect } from 'react-router';
import store from '../../store';
import { getUserInformation } from '../../reducers/user/userReducer';
import { viewContext } from './context';
import { getServiceUnavailablePath } from '../../helpers/serviceUnavailableHelper';
import { getTargetOrigins } from '../../helpers/postMessageHelper';
import { isTestMode } from '../../helpers/urlHelper';
import { isAppViewGuestUser } from '../../helpers/appViewHelper';

let initialAuthCheckDone = false;

const authMiddleware: MiddlewareFunction = async ({ context }) => {
  if (initialAuthCheckDone) {
    return;
  }
  initialAuthCheckDone = true;
  const view = context.get(viewContext);

  // In alt view with target origins configured, the auth token arrives via
  // post-message from the embedding page. Skip the parent-frame login flow.
  if (view === 'alt' && getTargetOrigins().length > 0) {
    return;
  }

  try {
    await store.dispatch(getUserInformation(view)).unwrap();
  } catch {
    if (view === 'app' && !isTestMode() && !isAppViewGuestUser()) {
      const serviceUnavailablePath = getServiceUnavailablePath(true);
      window.history.replaceState(null, '', serviceUnavailablePath);
      throw redirect(serviceUnavailablePath);
    }
  }
};

export default authMiddleware;
